export class ActivityConstants {
	static readonly FRIENDLY_NAME = "Activity";
	public static DOCUMENT_SUBMIT_ACTIVITYLOG_TEXT = (formName: string, documentId: string) => `Submitted "${formName}" document "${documentId}"`;
}
